/**
 * 雲幣格式化工具
 * 確保所有雲幣金額都保留到小數點後兩位
 */

/**
 * 格式化雲幣金額到小數點後兩位
 * @param amount 原始金額
 * @returns 格式化後的金額（四捨五入到小數點後兩位）
 */
export function formatCoin(amount: number): number {
  if (isNaN(amount) || !isFinite(amount)) {
    return 0;
  }
  return Math.round(amount * 100) / 100;
}

/**
 * 格式化雲幣金額並轉為字串顯示
 * @param amount 原始金額
 * @param showUnit 是否顯示「雲幣」單位
 * @returns 格式化後的字串
 */
export function formatCoinDisplay(amount: number, showUnit: boolean = false): string {
  const formatted = formatCoin(amount);
  return showUnit ? `${formatted.toFixed(2)} 雲幣` : formatted.toFixed(2);
}

/**
 * 計算雲幣金額（帶手續費）
 * @param amount 原始金額
 * @param feeRate 手續費率（預設 0.05 = 5%）
 * @returns { total: 總額, amount: 實收金額, fee: 手續費 }
 */
export function calculateCoinWithFee(amount: number, feeRate: number = 0.05): {
  total: number;
  amount: number;
  fee: number;
} {
  const total = formatCoin(amount);
  const fee = formatCoin(total * feeRate);
  const netAmount = formatCoin(total - fee);
  
  return {
    total,
    amount: netAmount,
    fee
  };
}

/**
 * 批次格式化雲幣數組
 * @param amounts 金額數組
 * @returns 格式化後的金額數組
 */
export function formatCoinArray(amounts: number[]): number[] {
  return amounts.map(amount => formatCoin(amount));
}

/**
 * 驗證雲幣金額是否有效
 * @param amount 金額
 * @param minAmount 最小金額（預設 0）
 * @returns 是否有效
 */
export function isValidCoinAmount(amount: number, minAmount: number = 0): boolean {
  return !isNaN(amount) && isFinite(amount) && amount >= minAmount;
}
